export class EDesignDetailDto {
  id?: string;
  environment: string;
  eDesignId: string;
  url?: string;
  name?: string;
  type?: string;

  constructor(d?: EDesignDetailDto) {
    Object.assign(this, d || {});
  }
}
